export class CookieStorage {
  clear() {
    const strExpires = 'Thu, 01 Jan 1970 00:00:01 GMT';
    window.document.cookie = `${process.env.TOKEN_NAME}=; expires=${strExpires};`;
    window.document.cookie = `${process.env.REFRESH_TOKEN_NAME}=; expires=${strExpires};`;
    return window.document.cookie = `${process.env.TOKEN_NAME_AUTH0}=; expires=${strExpires};`;
  }

  getItem(key) {
    const pattern = new RegExp(`(?:(?:^|.*;\\s*)${process.env.TOKEN_NAME}\\s*\\=\\s*([^;]*).*$)|^.*$`);
    const token = window.document.cookie.replace(pattern, '$1');

    const patternAuth0 = new RegExp(`(?:(?:^|.*;\\s*)${process.env.TOKEN_NAME_AUTH0}\\s*\\=\\s*([^;]*).*$)|^.*$`);
    const tokenAuth0 = window.document.cookie.replace(patternAuth0, '$1');
    if(tokenAuth0) {
      return tokenAuth0
    }
    return token;
  }

  setItem(key, data) {
    return window.document.cookie = `${key}=${data};domain=${process.env.DOMAIN_NAME};path=/`
  }
}
